import { withStateHandlers } from 'recompose'


export default withStateHandlers(
  { codeType: '' },
  { setCodeType: () => codeType => ({ codeType }) }
)



// WEBPACK FOOTER //
// ./components/hoc/codeTypeSelect.js